import { useState, useEffect } from 'react'

/**
 * Observes the main header's break attribute to stay in sync with its responsive state.
 * The header uses dynamic content-based breakpoints, not viewport-based ones,
 * so we observe its actual state rather than trying to recalculate independently.
 *
 * @returns {string|null} The current header breakpoint: 'mobile', 'tablet', 'desktop', or null if not found
 */
export default function useHeaderBreakpoint() {
  const [breakpoint, setBreakpoint] = useState(null)

  useEffect(() => {
    const headerEl = document.querySelector('header[break]')
    if (!headerEl) return undefined

    const updateBreakpoint = () => {
      setBreakpoint(headerEl.getAttribute('break'))
    }

    // Set initial value
    updateBreakpoint()

    // Observe changes
    const observer = new MutationObserver(updateBreakpoint)
    observer.observe(headerEl, { attributes: true, attributeFilter: ['break'] })

    return () => observer.disconnect()
  }, [])

  return breakpoint
}
